import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { Link, useNavigate, useParams } from 'react-router-dom';
import DropdownList from 'react-widgets/DropdownList';
import { Button } from 'src/lib/components/Button.component';
import { Checkbox } from 'src/lib/components/Checkbox.component';
import { Datepicker, DatePickerRef } from 'src/lib/components/DatePicker.component';
import { getDropdownDefaultValue } from 'src/lib/components/DropdownList.component';
import { TextInput } from 'src/lib/components/TextInput.component';
import { dayts } from 'src/lib/dayjs';
import { fdelete, fget, fput, getUser } from 'src/lib/fetch';
import { AdEntity } from 'src/modules/ads/dto/ads.entity';

export function EditAdPage() {
  const eForm = useRef<HTMLFormElement>(null);

  const eDate = useRef<DatePickerRef>(null);
  const eTextWorker = useRef<HTMLInputElement>(null);
  const eSelectAdSource = useRef<HTMLSelectElement>({} as HTMLSelectElement);
  const eTextAdvertiser = useRef<HTMLInputElement>(null);
  const eTextIndustry = useRef<HTMLInputElement>(null);
  const eSelectToBToC = useRef<HTMLSelectElement>({} as HTMLSelectElement);
  const eTextCommodity = useRef<HTMLInputElement>(null);
  const eSelectMaterial = useRef<HTMLSelectElement>({} as HTMLSelectElement);
  const eTextSecond = useRef<HTMLInputElement>(null);

  const eTextAge = useRef<HTMLSelectElement>({} as HTMLSelectElement);
  const eSelectGender = useRef<HTMLSelectElement>({} as HTMLSelectElement);
  const eTextPrefecture = useRef<HTMLInputElement>(null);
  const eTextProfession = useRef<HTMLInputElement>(null);
  const eSelectOperator = useRef<HTMLSelectElement>({} as HTMLSelectElement);
  const eTextCapture = useRef<HTMLInputElement>(null);
  const eTextDestination = useRef<HTMLInputElement>(null);
  const eTextComment = useRef<HTMLInputElement>(null);

  const eButtonSubmit = useRef<HTMLButtonElement>(null);
  const eButtonDelete = useRef<HTMLButtonElement>(null);

  const eButtonModeEdit = useRef<HTMLInputElement>(null);

  const [ad, setAd] = useState<AdEntity>();
  const [captureUrl, setCaptureUrl] = useState<URL>();
  const [checkedModeEdit, setCheckedModeEdit] = useState<boolean>(false);

  const params = useParams();

  const navigate = useNavigate();

  const currentUser = getUser();

   // サイドヘッダーオープン
   const [isOpen, setIsOpen] = useState(false);

   const handleClick = () => {
     setIsOpen(!isOpen);
   };
 
   useEffect(() => {
     if (isOpen) {
       document.body.classList.add('open');
     } else {
       document.body.classList.remove('open');
     }
   }, [isOpen]);
   // サイドヘッダーオープン END

  function handleButtonSubmit(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    if (!eForm.current?.checkValidity()) return eForm.current?.reportValidity();

    fput<Partial<AdEntity>>(`media/getMedia/${params.id}`, {
      body: {
        worker: eTextWorker.current?.valueAsNumber || 0,
        mediaSource: eSelectAdSource.current?.value || '',
        advertiser: eTextAdvertiser.current?.value || '',
        industry: eTextIndustry.current?.value || '',
        tocTob: eSelectToBToC.current?.value || '',
        commodity: eTextCommodity.current?.value || '',
        material: eSelectMaterial.current?.value || '',
        age: eTextAge.current?.value || '',
        sex: eSelectGender.current?.value || '',
        prefecture: eTextPrefecture.current?.value || '',
        profession: eTextProfession.current?.value || '',
        isoAndroid: eSelectOperator.current?.value || '',
        capture: eTextCapture.current?.value || '',
        transitionDestination: eTextDestination.current?.value || '',
        comment: eTextComment.current?.value || '',
        day: dayts(eDate.current?.value).date(),
        month: dayts(eDate.current?.value).month(),
        year: dayts(eDate.current?.value).year(),
        ...(eTextSecond.current ? { numberSeconds: eTextSecond.current.value } : {}),
      },
      onErrorMoveToLocation: '/dashboard/logout',
    }).then(() => {
      navigate('..');
    });
  }

  function handleButtonDelete(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    if (!eForm.current?.checkValidity()) return eForm.current?.reportValidity();

    fdelete(`media/getMedia/${params.id}`, {
      onErrorMoveToLocation: '/dashboard/logout',
    }).then(() => {
      navigate('..');
    });
  }

  useEffect(() => {
    fget<unknown, typeof ad>(`media/getMedia/${params.id}`, {
      onErrorMoveToLocation: '/dashboard/logout',
    }).then(([_, ad]) => {
      setAd(ad);
      setCaptureUrl(ad ? new URL(ad.capture) : undefined);
    });
  }, []);

  return (
    <form className="flex flex-row flex-wrap justify-evenly px-16 py-10 dashboard-wrap-top" ref={eForm}>
      <div className='login-header-wrap'>
        <div className={`dashboard-btn-div cp_hmenuac01${isOpen ? ' active' : ''}`} onClick={handleClick}><span className="cp_bar"></span></div>
      </div>
      <span
        className="w-full border-b border-slate-800 d-sm-none"
        style={{
          minWidth: '24rem',
        }}></span>

      <div className="mb-2 mt-sm-2 flex basis-full justify-end">
        {currentUser?.role === 'ADMIN' && (
          <Checkbox
            className="hidden"
            onChange={(e) => setCheckedModeEdit(e.target.checked)}
            defaultChecked={checkedModeEdit}
            ref={eButtonModeEdit}
            containerProps={{
              className: `ml-auto border border-gray-500`,
            }}
            labelProps={{
              children: '編集モード',
              className: `select-none p-2 ${currentUser?.role == 'ADMIN' ? '' : 'cursor-not-allowed'}  ${
                checkedModeEdit ? 'bg-black text-white' : ''
              }`,
            }}
          />
        )}
      </div>

      {ad && (
        <div className="flex flex-wrap justify-center gap-8 mt-sm-2">
          <div className="grid grid-rows-4 gap-4">
            <div className="row-span-3 max-w-[21rem]">
              {(() => {
                if (!captureUrl)
                  return (
                    <div
                      className="flex items-center justify-center border border-gray-300"
                      style={{
                        height: '44rem',
                        width: '20rem',
                      }}>
                      <img src="/no-image-svgrepo-com.svg" className="h-12 w-12" />
                    </div>
                  );

                captureUrl.searchParams.delete('dl');
                captureUrl.searchParams.append('raw', '1');

                const isVideoUrl =
                  '|.ty+|.str|.swf|.aep|.mkv|.pz|.plot|.sfd|.kine|.drp|.psv|.prproj|.piv|.veg|.vproj|.inp|.pic|.anm|.cpvc|.plotdoc|.scm|.wlmp|.msdvd|.aec|.bik|.kdenlive|.mswmm|.dcr|.webm|.amc|.scm|.vpj|.wpl|.dir|.mp4|.fcp|.fbr|.evo|.srt|.dcr|.vob|.mse|.rmvb|.sbt|.clpi|.flc|.sub|.ssf|.vsp|.pac|.ifo|.3gp|.mxf|.cine|.dmsm|.rec|.camproj|.mvd|.ivr|.dmx|.vp6|.vtt|.alpx|.sqz|.m4u|.dpa|.av1|.wmmp|.meta|.tsv|.mpeg|.trp|.swi|.gts|.rcd|.db2|.aepx|.mgv|.screenflow|.mvp|.mpv|.amx|.mani|.d3v|.hdmov|.rms|.video|.ismv|.3gp2|.viv|.wmv|.asf|.vc1|.ogv|.flv|.psh|.dmsm3d|.ncor|.pmf|.ser|.jtv|.ale|.mys|.zm2|.siv|.meps|.rcut|.g2m|.arcut|.exi|.gfp|.tvshow|.mpsub|.m2ts|.dv4|.mproj|.dxr|.mp4v|.mp4.infovid|.ts|.mob|.dat|.m1v|.cme|.mp5|.idx|.scc|.zmv|.iva|.mj2|.psb|.m2t|.dream|.mepx|.m4v|.rm|.mpeg4|.dzm|.trec|.camrec|.tix|.theater|.smv|.mjpg|.bk2|.mnv|.wp3|.stx|.vro|.awlive|.f4p|.mpg|.xmv|.vgz|.wvm|.dash|.mov|.dzp|.dv|.tp|.mts|.pds|.int|.dvr-ms|.dvr|.tmv|.mmp|.sedprj|.pclx|.avv|.dzt|.ircp|.mv|.ppj|.ffd|.avb|.dmb|.cst|.m4s|.zm3|.ktn|.kmproject|.fbr|.izz|.sfvidcap|.camv|.fli|.vii|.qtch|.m75|.mep|.izzy|.vid|.264|.bnp|.playlist|.wvx|.avchd|.dav|.sbk|.cpi|.3mm|.vep|.h264|.3g2|.mp2v|.xesc|.sfera|.m15|.264|.mvp|.rdb|.mpeg2|.bsf|.jdr|.60d|.xvid|.lvix|.d2v|.ddat|.san|.pgi|.890|.yuv|.aaf|.ism|.movie|.g64x|.g64|.media|.f4v|.mpv2|.mpl|.3gpp|.jss|.pdrproj|.mp21|.mvex|.tbc|.r3d|.qtl|.mmv|.wve|.dck|.hdv|.mk3d|.dnc|.xlmv|.rsx|.tsp|.pro|.f4f|.m4f|.vcr|.bdmv|.vp3|.divx|.hevc|.m2p|.ogm|.nut|.moi|.swt|.smk|.wcp|.nuv|.rv|.k3g|.spl|.ogx|.wm|.xml|.kmv|.avi|.dpg|.bu|.ced|.dvdmedia|.3gpp2|.rum|.tvlayer|.tdt|.lrec|.3p2|.exo|.wrf|.mpe|.787|.arf|.wmd|.rmd|.bdt3|.mtv|.flic|.tivo|.m2a|.vp7|.bmc|.nfv|.tvs|.lsx|.lrv|.mpg4|.gvi|.moov|.aqt|.tpd|.dmsd|.rmp|.aetx|.jmv|.mjp|.prel|.zoom|.wxp|.f4m|.mvc|.v264|.nvc|.asx|.imovieproj|.y4m|.bvr|.movie|.ttxt|.irf|.ajp|.ftc|.ave|.avp|.smil|.fvm|.wtv|.bdm|.tvrecording|.otrkey|.ntp|.mve|.mv8|.axv|.wot|.m4e|.avd|.prtl|.imovielibrary|.m2v|.vse|.pjs|.avs|.vcv|.flh|.sub|.evo|.m21|.pxv|.hkm|.n3r|.vr|.rcrec|.sbz|.tpr|.imoviemobile|.roq|.fpdx|.peg|.vbc|.sdv|.rvid|.vdr|.rvl|.bmk|.plproj|.zeg|.mpgindex|.ismc|.cmproj|.photoshow|.cmmtpl|.zm1|.gxf|.tod|.tda3mt|.ivf|.dvx|.dvt|.braw|.projector|.lfpackage|.ttml|.m21|.ssm|.orv|.qt|.insv|.vivo|.mpeg1|.aegraphic|.mpl|.sec|.mt2s|.wmx|.edl|.par|.sec|.vcpf|.qtm|.rmd|.yog|.w32|.pns|.gifv|.gcs|.amv|.xel|.crec|.vix|.clk|.nsv|.av|.thp|.pvr|.am|.ravi|.pssd|.dv-avi|.fcproject|.vfz|.smi|.anim|.ssa|.vfw|.seq|.proqc|.fcarch|.byu|.m1pg|.blz|.mpc|.vs4|.vlab|.bs4|.qsv|.mxv|.vmd|.modd|.mvb|.mpls|.dif|.mod|.tp0|.qtz|.viewlet|.xfl|.bix|.gl|.spryzip|.wsve|.vem|.vdo|.ezt|.jts|.axm|.dmss|.imovieproject|.aet|.cmrec|.aecap|.vf|.dad|.dlx|.ffm|.pro4dvd|.cmmp|.vdx|.xej|.mpg2|.cvc|.svi|.exp|.usf|.stl|.smi|.moff|.fbz|.lsf|.msh|.fvt|.jv|.seq|.dce|.cmv|.cip|.h261|.ivs|.scn|.pva|.eyetv|.avm|.h265|.lxf|.gom|.avs|.mqv|.wgi|.rcproject|.rmv|.avr|.eye|.mjpeg|.dmsd3d|.tdx|.ty|.ismclip|.mvy|.avs|.wfsp|.anydesk|.bik2|.vmlf|.cam|.vmlt|.cdxl|.drc|.vsr|.vp5|.anx|.pmp|.pro5dvd|.el8|.cx3|.camtemplate|.skm|.avc|.bdt2|.rts|.qtindex|.gvp|.mp21|.tid|.qsmd|.rp|.mpf|.sml|.p64|.movie|.lvf|.jnr|.flx|.vsh|.h263|.av3|.kux|.vft|.grasp|.ml20|.h262|.paf|.dsy|.tgv|.tgq|.rpl|.rl2|.mvi|.pmv|.cel|.rts|.pjr|'.includes(
                    `|.${captureUrl.pathname.split('.').at(-1) || ''}|`,
                  );

                return (
                  // <div
                  //   className="relative inline-flex justify-center overflow-hidden rounded-md shadow-xl"
                  //   style={{
                  //     height: '42rem',
                  //   }}>
                  ad.material === '静止画' && !isVideoUrl ? (
                    <img
                      src={captureUrl.href}
                      style={{
                        height: '44rem',
                      }}
                      loading={'lazy'}
                      className="cursor-pointer object-cover transition duration-1000 ease-in-out group-hover:scale-125 group-hover:brightness-50"
                    />
                  ) : (
                    <ReactPlayer url={captureUrl.href} width="auto" height="44rem" controls pip />
                  )
                  // </div>
                );
              })()}
            </div>

            <TextInput
              labelProps={{
                children: 'Dropboxリンク',
              }}
              type="text"
              defaultValue={ad.capture}
              containerProps={{
                style: {
                  minWidth: '12rem',
                },
              }}
              onChange={(e) => {
                let captureURL = new URL(`http://${window.location.host}/marker-icon.png`);
                try {
                  captureURL = new URL(e.target.value);

                  captureURL.searchParams.delete('dl');
                  captureURL.searchParams.append('raw', '1');

                  setCaptureUrl(captureURL);
                } catch {
                  setCaptureUrl(undefined);
                }
              }}
              required
              ref={eTextCapture}
              disabled={!checkedModeEdit}
            />
          </div>

          <div
            className="grid grid-cols-1 gap-4 sm:grid-cols-2 2xl:grid-cols-3 min-w-sm-25"
            style={{
            }}>
            <span className="col-span-full text-lg font-semibold">この広告の特徴</span>

            <Datepicker
              labelProps={{
                children: '収集日',
              }}
              valueDisplayFormat={{
                month: 'numeric',
                year: 'numeric',
                day: 'numeric',
              }}
              valueFormat={{
                month: 'numeric',
                year: 'numeric',
                day: 'numeric',
              }}
              valueEditFormat={{
                month: 'numeric',
                year: 'numeric',
                day: 'numeric',
              }}
              messages={{
                moveToday: '今日',
              }}
              className="w-full"
              includeTime={false}
              defaultValue={dayts(`${ad.year}-${ad.month}-${ad.day}`, { format: 'YYYY-MM-DD' }).toDate()}
              locale="ja"
              containerProps={{
                style: {
                  minWidth: '12rem',
                },
              }}
              ref={eDate}
              disabled={!checkedModeEdit}
            />

            <TextInput
              labelProps={{
                children: '作業者',
              }}
              type="text"
              defaultValue={ad.worker}
              containerProps={{
                className: 'basis-full',
                style: {
                  minWidth: '12rem',
                },
              }}
              required
              ref={eTextWorker}
              disabled={!checkedModeEdit}
            />

            <div>
              <label className="mb-2 block text-sm font-normal text-gray-900 dark:text-white" children="媒体" />
              <DropdownList
                data={[
                  {
                    url: `http://${window.location.host}/assets/facebook-svgrepo-com.svg`,
                    label: 'Facebook',
                  },
                  {
                    url: `http://${window.location.host}/assets/instagram-svgrepo-com.svg`,
                    label: 'Instagram',
                  },
                  {
                    url: `http://${window.location.host}/assets/twitter-svgrepo-com.svg`,
                    label: 'Twitter',
                  },
                  {
                    url: `http://${window.location.host}/assets/line-svgrepo-com.svg`,
                    label: 'LINE',
                  },
                  {
                    url: `http://${window.location.host}/assets/tiktok-svgrepo-com.svg`,
                    label: 'TikTok',
                  },
                ]}
                defaultValue={getDropdownDefaultValue(ad.mediaSource, eSelectAdSource.current)}
                dataKey="label"
                textField="label"
                renderListItem={({ item }) => {
                  return (
                    <div className="flex items-center gap-2">
                      <img src={item.url} className="h-5 w-5" />
                      <span>{item.label}</span>
                    </div>
                  );
                }}
                onChange={(v) => {
                  eSelectAdSource.current.value = v.label;
                }}
                // ref={eSelectAdSource}
                disabled={!checkedModeEdit}
              />
            </div>

            <TextInput
              labelProps={{
                children: '広告主',
              }}
              type="text"
              defaultValue={ad.advertiser}
              containerProps={{
                className: 'basis-full',
                style: {
                  minWidth: '12rem',
                },
              }}
              required
              ref={eTextAdvertiser}
              disabled={!checkedModeEdit}
            />

            <TextInput
              labelProps={{
                children: '業種',
              }}
              type="text"
              defaultValue={ad.industry}
              containerProps={{
                className: 'basis-full',
                style: {
                  minWidth: '12rem',
                },
              }}
              required
              ref={eTextIndustry}
              disabled={!checkedModeEdit}
            />

            <div>
              <label className="mb-2 block text-sm font-normal text-gray-900 dark:text-white" children="ToC or ToB" />
              <DropdownList
                data={['ToB', 'ToC']}
                defaultValue={getDropdownDefaultValue(ad.tocTob, eSelectToBToC.current)}
                onChange={(v) => {
                  eSelectToBToC.current.value = v;
                }}
                // ref={eSelectToBToC}
                disabled={!checkedModeEdit}
              />
            </div>

            <TextInput
              labelProps={{
                children: '商材',
              }}
              type="text"
              defaultValue={ad.commodity}
              containerProps={{
                className: 'basis-full',
                style: {
                  minWidth: '12rem',
                },
              }}
              required
              ref={eTextCommodity}
              disabled={!checkedModeEdit}
            />

            <div>
              <label className="mb-2 block text-sm font-normal text-gray-900 dark:text-white" children="素材" />
              <DropdownList
                data={['静止画', '動画']}
                defaultValue={getDropdownDefaultValue(ad.material, eSelectMaterial.current)}
                onChange={(v) => {
                  eSelectMaterial.current.value = v;
                }}
                // ref={eSelectMaterial}
                disabled={!checkedModeEdit}
              />
            </div>
            <TextInput
              labelProps={{
                children: '秒数',
              }}
              type="number"
              defaultValue={ad.numberSeconds}
              containerProps={{
                className: 'basis-full',
                style: {
                  minWidth: '12rem',
                },
              }}
              required
              ref={eTextSecond}
              disabled={!checkedModeEdit}
            />

            <span className="col-span-full text-lg font-semibold">この広告が表示されたユーザーの特徴</span>

            {/*<TextInput*/}
            {/*  labelProps={{*/}
            {/*    children: '年齢',*/}
            {/*  }}*/}
            {/*  type="text"*/}
            {/*  defaultValue={ad.age}*/}
            {/*  containerProps={{*/}
            {/*    className: 'basis-full',*/}
            {/*    style: {*/}
            {/*      minWidth: '12rem',*/}
            {/*    },*/}
            {/*  }}*/}
            {/*  required*/}
            {/*  ref={eTextAge}*/}
            {/*  disabled={!checkedModeEdit}*/}
            {/*/>*/}
            <div>
              <label className="mb-2 block text-sm font-normal text-gray-900 dark:text-white" children="年齢" />
              <DropdownList
                data={['10', '20', '30', '40', '50', '60', '70', '80']}
                defaultValue={getDropdownDefaultValue(ad.age, eTextAge.current)}
                onChange={(v) => {
                  eTextAge.current.value = v;
                }}
                ref={eTextAge}
                disabled={!checkedModeEdit}
              />
            </div>

            <div>
              <label className="mb-2 block text-sm font-normal text-gray-900 dark:text-white" children="性別" />
              <DropdownList
                data={['男性', '女性']}
                defaultValue={getDropdownDefaultValue(ad.sex, eSelectGender.current)}
                onChange={(v) => {
                  eSelectGender.current.value = v;
                }}
                // ref={eSelectGender}
                disabled={!checkedModeEdit}
              />
            </div>

            {/*<TextInput*/}
            {/*  labelProps={{*/}
            {/*    children: '性別',*/}
            {/*  }}*/}
            {/*  type="text"*/}
            {/*  defaultValue={ad.sex}*/}
            {/*  containerProps={{*/}
            {/*    className: 'basis-full',*/}
            {/*    style: {*/}
            {/*      minWidth: '12rem',*/}
            {/*    },*/}
            {/*  }}*/}
            {/*  required*/}
            {/*  ref={eTextGender}*/}
            {/*  disabled={!checkedModeEdit}*/}
            {/*/>*/}

            <TextInput
              labelProps={{
                children: '都道府県',
              }}
              type="text"
              defaultValue={ad.prefecture}
              containerProps={{
                className: 'basis-full',
                style: {
                  minWidth: '12rem',
                },
              }}
              required
              ref={eTextPrefecture}
              disabled={!checkedModeEdit}
            />

            <TextInput
              labelProps={{
                children: '職業',
              }}
              type="text"
              defaultValue={ad.profession}
              containerProps={{
                className: 'basis-full',
                style: {
                  minWidth: '12rem',
                },
              }}
              required
              ref={eTextProfession}
              disabled={!checkedModeEdit}
            />

            <div>
              <label
                className="mb-2 block text-sm font-normal text-gray-900 dark:text-white"
                children="iOS or Android"
              />
              <DropdownList
                data={['iOS', 'Android']}
                defaultValue={getDropdownDefaultValue(ad.isoAndroid, eSelectOperator.current)}
                onChange={(v) => {
                  eSelectOperator.current.value = v;
                }}
                // ref={eSelectOperator}
                disabled={!checkedModeEdit}
              />
            </div>

            <TextInput
              labelProps={{
                children: '広告リンク先',
              }}
              type="text"
              defaultValue={ad.transitionDestination}
              containerProps={{
                className: 'basis-full',
                style: {
                  minWidth: '12rem',
                },
              }}
              required
              ref={eTextDestination}
              disabled={!checkedModeEdit}
            />

            <TextInput
              labelProps={{
                children: 'コメント',
              }}
              type="text"
              defaultValue={ad.comment}
              containerProps={{
                className: 'basis-full',
                style: {
                  minWidth: '12rem',
                },
              }}
              ref={eTextComment}
              disabled={!checkedModeEdit}
            />

            {checkedModeEdit && (
              <div className="col-span-full block basis-full justify-center">
                <Button
                  className="mx-auto mt-6 rounded-md bg-black text-xs text-white"
                  style={{
                    minWidth: '256px',
                  }}
                  type="submit"
                  onClick={handleButtonSubmit}
                  ref={eButtonSubmit}>
                  確定
                </Button>
                {/* <Button
                  className="mx-auto mt-6 rounded-md border bg-transparent text-xs text-orange-600"
                  style={{
                    minWidth: '256px',
                  }}
                  type="submit"
                  onClick={handleButtonDelete}
                  ref={eButtonDelete}>
                  削除
                </Button> */}
              </div>
            )}
            {/* <Link
              className="col-span-full mx-auto mt-4 min-w-[3rem] cursor-pointer select-none text-center hover:underline hover:underline-offset-4"
              to="..">
              {eButtonModeEdit.current?.checked ? 'キャンセル' : '戻る'}
            </Link> */}
          </div>
        </div>
      )}
    </form>
  );
}
